import { ColumnTypes } from '../';

export const getColumns = (): ColumnTypes => [
	{
		title: `배정기간`,
		dataIndex: 'allocationPeriod',
		key: 'allocationPeriod',
		align: 'center',
	},
	{
		title: '배정인원/요청인원',
		dataIndex: 'assignmentApplicantPerRequestApplicant',
		key: 'assignmentApplicantPerRequestApplicant',
		align: 'center',
	},
	{
		title: '특이사항',
		dataIndex: 'memo',
		key: 'memo',
		align: 'center',
	},
];

export const HEADER_HEIGHT = 40;
export const TH_HEIGHT = 48;
export const TR_HEIGHT = 52;
